import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITrainingTemplate, ITrainingTemplateResource } from "../types";

export interface ITrainingTemplateQueryParameters {
    trainingTemplate?: RelationalValue<ITrainingTemplateResource>;
}

export type ITrainingTemplateQueryResult = ITrainingTemplate;

export const trainingTemplateQuery: IApiQueryFunction<ITrainingTemplateQueryParameters> = ({ trainingTemplate }) => {
    if (!trainingTemplate) {
        return;
    }

    return {
        method: "GET",
        url: `/training_templates/${mapRelationalValue(trainingTemplate)}`,
    };
};

export const useTrainingTemplateQuery = createApiQueryHook<
    ITrainingTemplateQueryParameters,
    ITrainingTemplateQueryResult
>(trainingTemplateQuery);
